export enum Sign {
  Debit = 'debit',
  Credit = 'credit',
}
